import moment from 'moment'

const TYPE_FORMAT_MAP = {
  year: {
    valueFormat: 'YYYY',
    momentFormat: ['YYYY']
  },
  month: {
    valueFormat: 'YYYY-MM',
    momentFormat: ['YYYY-MM', 'YYYYMM', 'YYYY/MM']
  },
  date: {
    valueFormat: 'YYYY-MM-DD',
    momentFormat: ['YYYY-MM-DD', 'YYYY-MM-DD', 'YYYY/MM/DD', 'YYYYMMDD']
  },
  datetime: {
    valueFormat: 'YYYY-MM-DD HH:mm:ss',
    momentFormat: ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss', 'YYYYMMDDHHmmss']
  }
}

// 输入的值正则，只能是 数字 - / : 的组合。
// const inputRegex = /^[0-9\-\\:/]*$/
const inputRegex = /^[0-9\-\\:/\s]*$/

export function parseInputDate ({input, type, isParseInputYear, panelYear, maxDate}) {
  input = String(input)
  // 增加额外的检查机制，因为moment太强大，能解析的场景太多，并且不正确的还会修正，比如2024对对对 直接修正为 2024-当前月-当前日
  // 如果包含中英文直接报错
  if (!inputRegex.test(input)) {
    return ''
  }
  const { valueFormat, momentFormat } = TYPE_FORMAT_MAP[type] || TYPE_FORMAT_MAP.datetime
  let str = isParseInputYear ? input : panelYear + input
  const parsedDate = moment(str, momentFormat)
  if (parsedDate.isValid()) {
    const time = parsedDate.format(valueFormat)
    if (moment(time).isAfter(moment(maxDate))) {
      return moment(maxDate).format(valueFormat)
    }
    return time
  } else {
    // 错误的解析
    return ''
  }
}

const TIME_FORMAT_MAP = {
  'HH:mm': {
    valueFormat: 'HH:mm',
    momentFormat: ['HHmm', 'HH:mm', 'HH-MM', 'HH/MM']
  },
  'HH:mm:ss': {
    valueFormat: 'HH:mm:ss',
    momentFormat: ['HHmmss', 'HH:mm:ss', 'HH-mm-ss', 'HH/mm/ss']
  },
}

export function parseTimeDate (input, format = 'HH:mm:ss', date) {
  try {
    input = String(input)
    // 如果包含中英文直接报错
    if (!inputRegex.test(input)) {
      return null
    }
    const { momentFormat, valueFormat } = TIME_FORMAT_MAP[format] || TIME_FORMAT_MAP['HH:mm']
    const parsedDate = moment(input, momentFormat)
    if (parsedDate.isValid()) {
      const ymd = moment(date).format('YYYY-MM-DD')
      const timeValue = parsedDate.format(valueFormat)
      const dateValue = ymd + ' ' + timeValue
      return {
        date: moment(dateValue).toDate(),
        timeValue,
        dateValue
      }
    } else {
      // 错误的解析
      return null
    }
  } catch (error) {
    console.error('【kye-date-picker2:parseTimeDate】format：错误，配置正确的格式 如 yyyyMMDD HH:mm:ss、yyyyMMDD HH:mm', error)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/utils/parse-input-date.js